import { type StateStore } from "@msys/ui";
import { type GridInitialState } from "@mui/x-data-grid-premium";
import { useUserPreference } from "./useUserPreference.js";

// here we make `useUserPreference` compatible with StateStore
export const useDataGridStateStore = (
  key: string,
  defaultValue?: GridInitialState | undefined
): StateStore => {
  return useUserPreference<GridInitialState | undefined>(
    `DataGrid-${key}`,
    defaultValue
  );
};
